import { NSARouterMakerResult, PaymentRequired } from "namirasoft-account-react";
import { AzureFullRow, AzureInputRow, AzureMetrics, AzureRow } from "namirasoft-bill-watch";
import { NSCCostChart } from "namirasoft-cost-react";
import { AzureRow as CredentialAzureRow } from "namirasoft-credential";
import { LogGroupRow } from "namirasoft-log";
import { TopicRow } from "namirasoft-notification-sender";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSBox, NSBoxBoolean, NSBoxEntity, NSBoxEnum, NSBoxInteger, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import React, { createRef } from "react";
import { BillWatchEntities } from "../BillWatchEntities";
import { BillWatchLayout } from '../BillWatchLayout';
import { BillWatchProps } from "../BillWatchProps";
import LookbackPeriods from "../components/LookbackPeriods";
import Rules from "../components/Rules";

interface AzureEditPageProps extends NSARouterMakerResult, BillWatchProps
{
    isEdit: boolean;
}

export default class AzureEditPage extends React.Component<AzureEditPageProps>
{
    NSBoxEntity_CredentialID = createRef<NSBoxEntity<CredentialAzureRow>>();
    NSBoxString_SubscriptionID = createRef<NSBoxString>();
    NSBoxEntity_TopicID = createRef<NSBoxEntity<TopicRow>>();
    NSBoxEntity_LogGroupID = createRef<NSBoxEntity<LogGroupRow>>();
    NSBoxString_Name = createRef<NSBoxString>();
    NSBoxBoolean_Active = createRef<NSBoxBoolean>();
    NSBoxBoolean_ShowAPICall = createRef<NSBoxBoolean>();
    NSBoxBoolean_ShowNewCost = createRef<NSBoxBoolean>();
    NSBoxBoolean_ShowOnDeactive = createRef<NSBoxBoolean>();
    NSBoxBoolean_ShowOnNoAnomaly = createRef<NSBoxBoolean>();
    NSBoxInteger_MaxAPICallTotal = createRef<NSBoxInteger>();
    NSBoxInteger_MaxAPICallPerOperation = createRef<NSBoxInteger>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();
    NSBoxEnum_Metrics = createRef<NSBoxEnum<AzureMetrics>>();
    Rules_Main = createRef<Rules>();
    LookbackPeriods_Main = createRef<LookbackPeriods>();

    override render()
    {
        let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

        return (
            <PaymentRequired
                {...this.props}
                tilte="Subscription is Required to Start Watching"
                description="Want to start watching your Azure usage? Subscribe to activate Bill Watch and begin tracking your costs with confidence. New users enjoy a 2-week free trial with no upfront fees. Subscribers may cancel their subscription at any time with no extra cost."
                button={{ action: "Activate" }}
                payment_offer_url="https://payment.namirasoft.com/offer/list/cost/usage"
                Validation={this.props.servers.bill_watch.azure.Validation}
            >
                <BillWatchLayout<AzureRow, AzureInputRow>
                    key="main"
                    {...this.props}
                    action={{
                        description: this.props.isEdit ? "You can edit a previous Azure watch and change its settings." : "You can create a new watch for Azure to monitor costs. Enter the required information, including account credentials and watch parameters.",
                    }}
                    pages={{
                        entity: BillWatchEntities.azure(this.props, () => { }),
                        edit: {
                            ...this.props,
                            ui: {
                                tab_page_edit: {
                                    editor: {
                                        getInputRow: () =>
                                        {
                                            let credential_id: string = this.NSBoxEntity_CredentialID.current?.getValueOne() ?? "";
                                            let subscription_id: string = this.NSBoxString_SubscriptionID.current?.getValue() ?? "";
                                            let topic_id: string = this.NSBoxEntity_TopicID.current?.getValueOne() ?? "";
                                            let log_group_id: string = this.NSBoxEntity_LogGroupID.current?.getValueOne() ?? "";
                                            let name: string = this.NSBoxString_Name.current?.getValue() ?? "";
                                            let active: boolean = this.NSBoxBoolean_Active.current?.getValue() ?? false;
                                            let show_api_call: boolean = this.NSBoxBoolean_ShowAPICall.current?.getValue() ?? false;
                                            let show_new_cost: boolean = this.NSBoxBoolean_ShowNewCost.current?.getValue() ?? false;
                                            let show_on_deactive: boolean = this.NSBoxBoolean_ShowOnDeactive.current?.getValue() ?? false;
                                            let show_on_no_anomaly: boolean = this.NSBoxBoolean_ShowOnNoAnomaly.current?.getValue() ?? false;
                                            let max_api_call_total: number = this.NSBoxInteger_MaxAPICallTotal.current?.getValue() ?? 0;
                                            let max_api_call_per_operation: number = this.NSBoxInteger_MaxAPICallPerOperation.current?.getValue() ?? 0;
                                            let metrics = this.NSBoxEnum_Metrics.current?.getValueEnumOne(AzureMetrics, AzureMetrics.ActualCost) ?? AzureMetrics.ActualCost;
                                            let rule_ids = this.Rules_Main.current?.NSRepeater_Rules.current?.getValue() ?? [];
                                            let lookback_periods = this.LookbackPeriods_Main.current?.NSRepeater_LookbackPeriods.current?.getValue() ?? [];
                                            let description: string = this.NSBoxTextArea_Description.current?.getValue() ?? "";
                                            return {
                                                workspace_id: "",
                                                credential_id,
                                                subscription_id,
                                                topic_id,
                                                log_group_id,
                                                name,
                                                active,
                                                show_api_call,
                                                show_new_cost,
                                                show_on_deactive,
                                                show_on_no_anomaly,
                                                max_api_call_total,
                                                max_api_call_per_operation,
                                                rule_ids,
                                                lookback_periods,
                                                metrics,
                                                description,
                                                azure_category: [],
                                                azure_field: [],
                                                azure_tag: [],
                                            };
                                        },
                                        setRow: (row) =>
                                        {
                                            let full_row = row as AzureFullRow;
                                            this.NSBoxEntity_CredentialID.current?.setValue(row.credential_id);
                                            this.NSBoxString_SubscriptionID.current?.setValue(row.subscription_id);
                                            this.NSBoxEntity_TopicID.current?.setValue(row.topic_id);
                                            this.NSBoxEntity_LogGroupID.current?.setValue(row.log_group_id);
                                            this.NSBoxString_Name.current?.setValue(row.name);
                                            this.NSBoxBoolean_Active.current?.setValue(row.active);
                                            this.NSBoxBoolean_ShowAPICall.current?.setValue(row.show_api_call);
                                            this.NSBoxBoolean_ShowNewCost.current?.setValue(row.show_new_cost);
                                            this.NSBoxBoolean_ShowOnDeactive.current?.setValue(row.show_on_deactive);
                                            this.NSBoxBoolean_ShowOnNoAnomaly.current?.setValue(row.show_on_no_anomaly);
                                            this.NSBoxInteger_MaxAPICallTotal.current?.setValue(row.max_api_call_total);
                                            this.NSBoxInteger_MaxAPICallPerOperation.current?.setValue(row.max_api_call_per_operation);
                                            this.NSBoxEnum_Metrics.current?.setValueOne(row.metrics);
                                            this.NSBoxTextArea_Description.current?.setValue(row.description);
                                            this.Rules_Main.current?.NSRepeater_Rules.current?.setValue(full_row.azure_rule.map(r => r.rule_id));
                                            this.LookbackPeriods_Main.current?.NSRepeater_LookbackPeriods.current?.setValue(full_row.lookback_periods);
                                        },
                                    },
                                    ui: {
                                        extra_tabs: [
                                            {
                                                title: "Rules",
                                                clicked: true,
                                                info: {
                                                    link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-rules"
                                                },
                                                getContent: () =>
                                                {
                                                    return <Rules
                                                        ref={this.Rules_Main}
                                                        {...this.props}
                                                        name="AzureEditPage"
                                                    />;
                                                }
                                            },
                                            {
                                                title: "Lookback Periods",
                                                clicked: true,
                                                info: {
                                                    link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-lookback-periods"
                                                },
                                                getContent: () =>
                                                {
                                                    return <LookbackPeriods
                                                        ref={this.LookbackPeriods_Main}
                                                        {...this.props}
                                                        name="AzureEditPage"
                                                    />;
                                                }
                                            },
                                            {
                                                title: "Metrics",
                                                clicked: true,
                                                info: {
                                                    link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-metrics"
                                                },
                                                getContent: () => (
                                                    <NSRow>
                                                        <NSBoxEnum<AzureMetrics>
                                                            ref={this.NSBoxEnum_Metrics}
                                                            title="Metrics"
                                                            required
                                                            multiple={false}
                                                            getEnumObject={() => AzureMetrics}
                                                            style={{ width: NSBox.width.double }}
                                                        />
                                                    </NSRow>
                                                )
                                            }
                                        ]
                                    }
                                },
                                tab_page_view: {
                                    tabs: {
                                        extra: {
                                            after_history: [
                                                NSCCostChart.getTab(this.props)
                                            ]
                                        }
                                    }
                                }
                            }
                        }
                    }}
                >
                    <NSColumn>
                        <NSRow>
                            <NSBoxString
                                ref={this.NSBoxString_Name}
                                required
                                title="Name"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-name" }}
                            />
                            <NSBoxBoolean
                                ref={this.NSBoxBoolean_Active}
                                required
                                defaultValue={true}
                                title="Active"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-active" }}
                            />
                        </NSRow>
                        <NSRow>
                            <NSBoxEntity<CredentialAzureRow>
                                ref={this.NSBoxEntity_CredentialID}
                                required
                                title="Azure Credential"
                                multiple={false}
                                table={namirasoft.credential.tables.azure}
                                getTitle={item => item.name}
                                getValue={item => item.id}
                                getSort={() => null}
                                style={{ width: NSBox.width.double }}
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-credential-id" }}
                            />
                        </NSRow>
                        <NSRow>
                            <NSBoxString
                                ref={this.NSBoxString_SubscriptionID}
                                required
                                title="Azure Subscription ID"
                                style={{ width: NSBox.width.double }}
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-subscription-id" }}
                            />
                        </NSRow>
                        <NSRow>
                            <NSBoxEntity<TopicRow>
                                ref={this.NSBoxEntity_TopicID}
                                required
                                title="Topic"
                                multiple={false}
                                table={namirasoft.notification_sender.tables.topic}
                                getTitle={item => item.name}
                                getValue={item => item.id}
                                getSort={() => null}
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-topic-id" }}
                            />
                            <NSBoxEntity<LogGroupRow>
                                ref={this.NSBoxEntity_LogGroupID}
                                required={true}
                                title="Log Group"
                                multiple={false}
                                table={namirasoft.log.tables.log_group}
                                getTitle={item => item.name}
                                getValue={item => item.id}
                                getSort={() => null}
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-log-group-id" }}
                            />
                        </NSRow>
                        <NSRow>
                            <NSBoxBoolean
                                ref={this.NSBoxBoolean_ShowAPICall}
                                required
                                defaultValue={true}
                                title="Show API Call"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-show-api-call" }}
                            />
                            <NSBoxBoolean
                                ref={this.NSBoxBoolean_ShowNewCost}
                                required
                                defaultValue={true}
                                title="Show New Cost"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-show-new-cost" }}
                            />
                        </NSRow>
                        <NSRow>
                            <NSBoxBoolean
                                ref={this.NSBoxBoolean_ShowOnDeactive}
                                required
                                defaultValue={true}
                                title="Show On Deactive"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-show-on-deactive" }}
                            />
                            <NSBoxBoolean
                                ref={this.NSBoxBoolean_ShowOnNoAnomaly}
                                required
                                defaultValue={true}
                                title="Show On No Anomaly"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-show-on-no-anomaly" }}
                            />
                        </NSRow>
                        <NSRow>
                            <NSBoxInteger
                                ref={this.NSBoxInteger_MaxAPICallTotal}
                                required
                                defaultValue={100}
                                title="Max API Call Total"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-max-api-call-total" }}
                            />
                            <NSBoxInteger
                                ref={this.NSBoxInteger_MaxAPICallPerOperation}
                                required
                                defaultValue={5}
                                title="Max API Call Per Operation"
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-max-api-call-per-operation" }}
                            />
                        </NSRow>
                        <NSRow>
                            <NSBoxTextArea
                                ref={this.NSBoxTextArea_Description}
                                required={false}
                                title="Description"
                                style={{ width: "100%" }}
                                info={{ link: "https://namirasoft.com/bill-watch/console-guide/azure/#field-description" }}
                            />
                        </NSRow>
                    </NSColumn>
                </BillWatchLayout>
            </PaymentRequired >
        );
    }
}